<div class="zag-translated-input" [class.zag-translated-input--disabled]="isDisabled()">
  @if (showTabStrip()) {
  <div
    class="zag-translated-input__tabs"
    role="tablist"
    [attr.aria-orientation]="'horizontal'"
    [attr.aria-label]="'translatableInput.tabsLabel' | translate"
  >
    @for (lang of languages(); track lang; let index = $index) {
    <button
      type="button"
      class="zag-translated-input__tab"
      [class.zag-translated-input__tab--active]="activeLanguage() === lang"
      [class.zag-translated-input__tab--filled]="filledLanguages().has(lang)"
      role="tab"
      [id]="tabIds()[lang]"
      [attr.aria-selected]="activeLanguage() === lang"
      [attr.aria-controls]="inputId()"
      [attr.tabindex]="activeLanguage() === lang ? 0 : -1"
      [disabled]="isDisabled()"
      (click)="selectLanguage(lang)"
      (keydown)="onTabKeydown($event, index)"
    >
      <span class="zag-translated-input__tab-label" [attr.aria-label]="'translatableInput.languageTab.' + lang | translate"
        >{{ lang | uppercase }}</span
      >
      <span
        class="zag-translated-input__tab-indicator"
        [class.zag-translated-input__tab-indicator--filled]="filledLanguages().has(lang)"
        [attr.aria-label]="
            (filledLanguages().has(lang)
              ? 'translatableInput.translationStatus.filled'
              : 'translatableInput.translationStatus.empty'
            ) | translate
          "
      ></span>
    </button>
    }
  </div>
  }

  <div class="zag-translated-input__panel" role="tabpanel" [id]="inputId() + '-panel'" [attr.aria-labelledby]="tabIds()[activeLanguage()]">
    @if (multiline()) {
    <textarea
      class="zag-translated-input__control zag-translated-input__textarea {{ inputClass() }}"
      [id]="inputId()"
      [name]="name() ?? null"
      [rows]="rows()"
      [placeholder]="effectivePlaceholder()"
      [disabled]="isDisabled()"
      [readonly]="readonly()"
      [required]="required() && activeLanguage() === languages()[0]"
      [value]="activeText()"
      [attr.aria-describedby]="ariaDescribedby() ?? null"
      [attr.aria-required]="required() && activeLanguage() === defaultLanguage() ? 'true' : null"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onTextareaKeydown($event)"
    ></textarea>
    } @else {
    <input
      class="zag-translated-input__control zag-translated-input__input {{ inputClass() }}"
      type="text"
      [id]="inputId()"
      [name]="name() ?? null"
      [placeholder]="effectivePlaceholder()"
      [disabled]="isDisabled()"
      [readonly]="readonly()"
      [required]="required() && activeLanguage() === languages()[0]"
      [value]="activeText()"
      [attr.aria-describedby]="ariaDescribedby() ?? null"
      [attr.aria-required]="required() && activeLanguage() === defaultLanguage() ? 'true' : null"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
    }
  </div>
</div>
